<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="file"></font-awesome-icon>
          {{ $t('clientBotDetect') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select v-if="!clientId" class="mr-1 mb-2" :model="filterFormModel"
                           attribute="client" :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-2"
                         :options="[
                             {value: null, text: $t('selectType') },
                             {value: 'chat', text: $t('chat') },
                             {value: 'call', text: $t('call') },
                         ]"></form-select>
            <form-select class="mr-1 mb-2" :model="filterFormModel" attribute="bot" :options="botOptions"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount > 0">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length > 0">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('client') }}</div>
            <div class="col-lg-1">{{ $t('type') }}</div>
            <div class="col-lg-1">{{ $t('bot') }}</div>
            <div class="col-lg-2">{{ $t('customer') }}</div>
            <div class="col-lg-3">{{ $t('content') }}</div>
            <div class="col-lg-2">{{ $t('createTime') }}</div>
            <div class="col-lg-1">{{ $t('account') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <span><b>{{ $t('name') }}: </b> {{ item.client.companyName }}</span>
              <span><b>Domain: </b>{{ item.client.domain }}</span>
            </div>
            <div class="col-lg-1">
              <p v-if="item.type">{{ $t(item.type) }}</p>
            </div>
            <div class="col-lg-1">
              <p v-if="item.bot">{{ item.bot.name }}</p>
            </div>
            <div class="col-lg-2">
              <p v-if="item.customer">{{ item.customer.name }}</p>
            </div>
            <div class="col-lg-3">
              <p v-if="item.content">{{ item.content }}</p>
            </div>
            <div class="col-lg-2">
              <p v-if="item.createTime">{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</p>
            </div>
            <div class="col-lg-1">
              <p v-if="item.account">{{ item.account.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="items.length === 0 && !loading">
        {{ $t('notFound') }}
      </div>
      <div class="col-12" v-if="itemCount > 0">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                        v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                        @input="load">
          </b-pagination>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import ClientSelect from "@/components/ClientSelect.vue";

export default {
  components: {ClientSelect, TimeRangePicker},
  mixins: [List],
  props: {
    clientId: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      service: '/client-bot-detect',
      autoLoad: true,
      defaultFilterFormModel: {
        client: this.clientId || null,
        type: null,
        bot: null,
      }
    }
  },
  computed: {
    botOptions() {
      const seen = new Set();
      const uniqueBots = this.items
          .filter(item => item.bot && !seen.has(item.bot._id) && seen.add(item.bot._id))
          .map(item => ({
            value: item.bot._id,
            text: item.bot.name
          }));

      return [
        {value: null, text: this.$t('selectBot')},
        ...uniqueBots
      ];
    }
  },
  i18n: {
    messages: {
      en: {
        clientBotDetect: "Client bot detect",
        type: "Type",
        bot: "Bot",
        customer: "Customer",
        content: "Content",
        createTime: "Create time",
        chat: "Chat",
        call: "Call",
        selectBot: "Select bot",
        selectType: "Select type",
        enterKeyword: "Enter keyword",
        account: "Account",
        notFound: "Not found any record",
      },
      vi: {
        clientBotDetect: "Lịch sử giám sát giao tiếp",
        type: "Loại",
        bot: "Nhóm",
        customer: "Khách hàng",
        content: "Nội dung",
        createTime: "Tạo lúc",
        chat: "Chat",
        call: "Gọi",
        selectBot: "Chọn nhóm",
        selectType: "Chọn loại",
        enterKeyword: "Nhập từ khóa",
        account: "Tài khoản mang xã hội",
        notFound: "Không tìm thấy bản ghi nào",
      }
    }
  }
}
</script>